module.exports = __webpack_public_path__ + "img/profile_jf1.e2c57cee.jpg";